import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./_css/inputSearch.module.css";
import clsx from "clsx";
import search from "../../../assets/images/search.svg";

export type TInputProps<T = string> = React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
> & {
    onValueChange?: (value: T, event?: React.ChangeEvent<HTMLInputElement>) => void;
    isHomePage?: boolean;
    onClickOnSearchIcon?: () => void;
};

/* eslint-disable react/prop-types */
export const InputSearch = React.forwardRef<HTMLInputElement, TInputProps>(
    ({ className, onValueChange, onChange, onClickOnSearchIcon, isHomePage, ...props }, ref) => {
        const { t } = useTranslation();
        return (
            <>
                {isHomePage ? (
                    <div className={clsx(styles.homeContainer, "flex_row_center")}>
                        <svg
                            className={styles.pinIcon}
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                        >
                            <path
                                d="M8 1.33334C5.42 1.33334 3.33334 3.42001 3.33334 6.00001C3.33334 9.50001 8 14.6667 8 14.6667C8 14.6667 12.6667 9.50001 12.6667 6.00001C12.6667 3.42001 10.58 1.33334 8 1.33334Z"
                                stroke="#AAAAAA"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M8 7.66668C8.92048 7.66668 9.66667 6.92048 9.66667 6.00001C9.66667 5.07954 8.92048 4.33334 8 4.33334C7.07953 4.33334 6.33334 5.07954 6.33334 6.00001C6.33334 6.92048 7.07953 7.66668 8 7.66668Z"
                                stroke="#AAAAAA"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                        <input
                            {...props}
                            className={styles.homeInput}
                            ref={ref}
                            onChange={(event) => {
                                if (onChange) onChange(event);
                                if (onValueChange) onValueChange(event.target.value);
                            }}
                        />
                        <div
                            className={clsx(styles.searchHomeBtn, "flex_center_center cursor_pointer")}
                            onClick={() => {
                                if (onClickOnSearchIcon) onClickOnSearchIcon();
                            }}
                        >
                            <svg
                                className={styles.searchHomeBtnIcon}
                                width="14"
                                height="14"
                                viewBox="0 0 14 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                            >
                                <path
                                    d="M6.41667 11.0833C8.994 11.0833 11.0833 8.994 11.0833 6.41667C11.0833 3.83934 8.994 1.75 6.41667 1.75C3.83934 1.75 1.75 3.83934 1.75 6.41667C1.75 8.994 3.83934 11.0833 6.41667 11.0833Z"
                                    stroke="white"
                                    strokeWidth="0.875"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M12.25 12.25L9.71252 9.71249"
                                    stroke="white"
                                    strokeWidth="0.875"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            <span className={styles.searchHomeBtnLabel}>
                                {t("propertiesPage.searchBar.search")}
                            </span>
                        </div>
                    </div>
                ) : (
                    <div className={clsx(styles.container, "flex_row_center")}>
                        <input
                            {...props}
                            className={clsx(styles.input, styles.primary)}
                            ref={ref}
                            onChange={(event) => {
                                if (onChange) onChange(event);
                                if (onValueChange) onValueChange(event.target.value);
                            }}
                        />
                        <img src={search} alt={"search"} className={styles.searchIcon} />
                    </div>
                )}
            </>
        );
    },
);
